module.exports = __webpack_public_path__ + "img/3.e310cf6f.png";